/**
 * Labstep
 *
 * @module components/Metadata/Detail
 * @desc Detail for Metadata Modal
 */

import { MetadataDetailValue } from 'labstep-web/components/Metadata/Detail/Value';
import { MetadataVariableDetail } from 'labstep-web/components/Metadata/Variable/Detail';
import ProtocolConditionActionCompareData from 'labstep-web/components/ProtocolCondition/Action/CompareData';
import { useProtocolConditionModalContext } from 'labstep-web/components/ProtocolCondition/Modal/context';
import { Collapsible } from 'labstep-web/core/Collapsible';
import { Divider } from 'labstep-web/core/Divider';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import { useLocation } from 'react-router-dom';
import MetadataDetailTableSettings from './Table/Settings';
import type { MetadataDetailProps } from './types';
export const MetadataDetail: React.FC<MetadataDetailProps> = ({
  metadata,
  entity,
}) => {
  const { state } = useLocation();
  const { isOpen } = useProtocolConditionModalContext();
  const settings = (
    <MetadataDetailTableSettings
      metadata={metadata}
      entity={entity}
    />
  );
  return (
    <Flex column grow style={{ justifyContent: 'space-around' }}>
      <Flex column grow style={{ overflowY: 'auto' }}>
        {isOpen ? (
          settings
        ) : (
          <Collapsible
            label={(expanded): React.ReactElement => (
              <span>
                <Icon name="cog" />
                {`${expanded ? 'Hide' : 'Show'} Settings`}
              </span>
            )}
            component={settings}
            // true when metadata first created
            initialExpandedState={(state as any)?.expanded}
            withChevron={false}
          />
        )}
        <Divider />
        {metadata.is_variable ? (
          <MetadataVariableDetail
            protocol={entity}
            metadata={metadata}
          />
        ) : (
          <MetadataDetailValue entity={entity} metadata={metadata} />
        )}
      </Flex>
      <ProtocolConditionActionCompareData
        actionComponentType="button"
        metadata={metadata}
      />
    </Flex>
  );
};
